import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToast } from 'hooks/ui';
import { approveTask } from 'api/task.service';
import { useApplicationStore } from 'store/application';
import { setDraftTask } from 'store/task';
import { taskKeys } from './queryKeys';

export const useTaskApproveQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate } = useMutation({
    mutationFn: (id: string) => {
      setLoading();

      return approveTask(id);
    },
    onSuccess: (task) => {
      toast.success('Task has been approved successfully');
      setDraftTask({ task });
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate };
};
